export default __webpack_public_path__ + "static/media/cesar.1072b01b.png";